/**
 * TanStack Query hooks for `real-time-event-alerts-module`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	realTimeEventAlertsModuleQueryKeys,
	type CreateRealTimeEventAlertsModuleBody,
	type ListRealTimeEventAlertsModuleResponse,
	type RealTimeEventAlertsModuleRow,
} from "./api";

export function useRealTimeEventAlertsModuleList(): UseQueryResult<ListRealTimeEventAlertsModuleResponse, Error> {
	return useQuery({
		queryKey: realTimeEventAlertsModuleQueryKeys.list(),
		queryFn: list,
	});
}

export function useRealTimeEventAlertsModuleCreate(): UseMutationResult<RealTimeEventAlertsModuleRow, Error, CreateRealTimeEventAlertsModuleBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeEventAlertsModuleQueryKeys.all });
		},
	});
}

export function useRealTimeEventAlertsModuleDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeEventAlertsModuleQueryKeys.all });
		},
	});
}
